/* emv/types */
import * as t from "io-ts";
function tOptional<T extends t.Mixed>(typeThing: T) {
  return t.union([t.undefined, t.null, typeThing]);
}
const tId = t.union([t.undefined, t.null, t.string]);
const ErrorCodec = t.type(
  {
    code: t.string,
    detail: t.string,
    title: t.string,
  },
  "ErrorCodec"
);
const BINSchema = t.type({
    Length: t.string,
    TokenBIN: t.string,
    From: t.string,
    To: t.string,
    CardType: t.string,
    Account: t.array(t.string)
})
const TOKENBINSchema = t.type({
  DescShort: t.string,
  DescLong: t.string,
  Bin: tOptional(t.array(BINSchema)),
});
const AttributeCodec = t.intersection([
  t.type({
    // Name: tOptional(t.string),
    // For: tOptional(t.string),
    // AID: tOptional(t.array(AIDSchema)),
    TokenBin: tOptional(t.array(TOKENBINSchema)),
    Name: t.string,
  }),
  t.partial({}),
]);
const DataCodec = t.type({
  id: tId,
  type: t.string,
  attributes: AttributeCodec,
});
export type Data = t.TypeOf<typeof DataCodec>;
export const TokenWalletCodec = t.type(
  {
    errors: tOptional(t.union([t.undefined, t.array(ErrorCodec)])),
    data: tOptional(t.array(DataCodec)),
  },
  "TokenWalletCodec"
);
export type TokenWallet = t.TypeOf<typeof TokenWalletCodec>;
export enum TokenWalletActionTypes {
  FETCH = "@@tokenwallet/FETCH",
  FETCH_SUCCESS = "@@tokenwallet/FETCH_SUCCESS",
  FETCH_ERROR = "@@tokenwallet/FETCH_ERROR",
}
export interface TokenWalletState {
  readonly loading: boolean;
  readonly data: Data[];
  readonly errors?: string;
}